/// <amd-module name="VSS/Features/Frame/FPSLink" />
export * from './FPSLink/FPSLink';
export { FPSLinkComponentProps } from './FPSLink/FPSLink.Props';
